










import { defineComponent, ref, onActivated, onDeactivated } from '@vue/composition-api';
import LoadingAnimation from '@/components/LoadingAnimation.vue';
import ViewContainer from '@/components/ViewContainer.vue';

export default defineComponent({
  name: 'UnityScene',
  props: {
    scene: String,
  },
  components: {
    ViewContainer,
    LoadingAnimation,
  },
  setup(props) {
    const loaded = ref(false);

    function deactivateWebview() {
      window.jrpc.call('WebView.SetVisibility', [false]);
    }
    onActivated(async () => {
      loaded.value = false;
      await window.jrpc.call('Unity.LoadScene', [props.scene]);
      loaded.value = true;
    });
    onDeactivated(async () => {
      await window.jrpc.call('WebView.SetVisibility', [true]);
    });
    return {
      loaded,
      deactivateWebview,
    };
  },
});
